module.exports = __webpack_public_path__ + "static/media/lkss.7cede635.png";